import { ExpenseField } from './ExpenseField.tsx';
import { ExpenseRow } from './ExpenseRow.tsx';
import { type ExpenseType, expenseTypeConfig } from './expenseTypeConfig.ts';
import type { ExpensesFormState } from '../hooks/useExpensesForm.ts';

type Props = {
    id: string;
    index: number;
    isSecondApplicant: boolean;
    onDelete: ExpensesFormState['onDelete'];
    type: ExpenseType;
};

export const ExpenseItem: React.FC<Props> = ({ id, index, isSecondApplicant, onDelete, type }) => {
    const config = expenseTypeConfig[type];

    return (
        <ExpenseRow
            onDelete={() => onDelete(type, id)}
            isSecondApplicant={isSecondApplicant}
            removeCommandName={config.removeCommand}
        >
            <ExpenseField
                name={`${type}.${index}.betragMonatlich`}
                label={config.label}
                isSecondApplicant={isSecondApplicant}
                commandName={config.changeCommand}
            />
        </ExpenseRow>
    );
};
